import { AuthGuard } from 'common-cloudstudio';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { DevicesComponent } from './devices/devices.component';
import { HistoricalDataComponent } from './historical-data/historical-data.component';
import { ModalCameraComponent } from './modal-camera/modal-camera.component';
import { TanksComponent } from './tanks/tanks.component';
import { SharedDashboardComponent } from './shared-dashboard/shared-dashboard.component';
import { ModalShareComponent } from './modal-share/modal-share.component';
import { SharedPlansComponent } from './shared-plans/shared-plans.component';
import { AssetTrackingComponent } from './asset-tracking/asset-tracking.component';
import { SharedAssetTrackingComponent } from './asset-tracking/shared-asset-tracking/shared-asset-tracking.component';
import { ModalSnapshotsComponent } from './modal-snapshots/modal-snapshots.component';
import { DeviceMapComponent } from './device-map/device-map.component';
import { DashboardsComponent } from './dashboards/dashboards.component';
import { ModalChangeValueEndpointsComponent } from './modal-change-value-endpoints/modal-change-value-endpoints.component';
import { PlansComponent } from './plans/plans.component';
import { IncidentMapComponent } from './incidents/incident-map/incident-map.component';
import { IncidentManagementComponent } from './incidents/incident-management/incident-management.component';



const appRoutes: Routes = [
    { path: '', redirectTo: 'default', pathMatch: 'full' },
    {
        path: 'customer',
        loadChildren: () => import('./customer-modules/customer/customer.module').then(m => m.CustomerModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'default',
        loadChildren: () => import('./default/default.module').then(m => m.DefaultModule),
        canActivate: [AuthGuard]
      },
    {
        path: 'map',
        loadChildren:() => import('./map/map.module').then(m => m.MapModule),
        canActivate: [AuthGuard]
    },
    {
      path: 'maps',
      loadChildren:() => import('./maps/map.module').then(m => m.MapsModule),
      canActivate: [AuthGuard]
  },
    {
        path: 'asset-tracking',
        loadChildren: () => import('./asset-tracking/asset-tracking.module').then(m => m.AssetTrackingModule),
        canActivate: [AuthGuard]
    },
    {
      path: 'dashboard',
      loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule),
      canActivate: [AuthGuard],
    },
    { path: 'devices', component: DevicesComponent, canActivate: [AuthGuard] },
    { path: 'devices-map', component: DeviceMapComponent, canActivate: [AuthGuard]},
    { path: 'devices-map/:deviceID', component: DeviceMapComponent, canActivate: [AuthGuard]},
    { path: 'incident-map', component: IncidentMapComponent, canActivate: [AuthGuard]},
    { path: 'endpoints-history', redirectTo: 'endpoints-history/history', pathMatch: 'full' },
    { path: 'endpoints-history/:type', component: HistoricalDataComponent, canActivate: [AuthGuard] },
    { path: 'camera/:url', component: ModalCameraComponent, outlet: 'modal', canActivate: [AuthGuard] },
    { path: 'incident-management', component: IncidentManagementComponent, canActivate: [AuthGuard] },
    { path: 'tanks', component: TanksComponent, canActivate: [AuthGuard] },
    { path: 'shared-dashboard/:genericToken', component: SharedDashboardComponent, data: { hideNav: true } },
    { path: 'shared-view/:genericToken', component: SharedPlansComponent, data: { hideNav: true } },
    { path: 'shared-assets/:genericToken', component: SharedAssetTrackingComponent, data: { hideNav: true } },
    { path: 'share-component/:type/:id', component: ModalShareComponent, outlet: 'modal', canActivate: [AuthGuard] },
    {
      path: 'incident-map',
      loadChildren: () => import('./incidents/incident-map/incident-map.module').then(m => m.IncidentMapModule),
      canActivate: [AuthGuard]
  },
   /*  {
        path: 'plans',
        loadChildren: () => import('common-cloudstudio').then(m => m.PlansModule),
        canActivate: [AuthGuard]
    }, */
/*     { path: 'plan', component: PlansComponent, canActivate: [AuthGuard] },
    { path: 'plan/:id', component: PlansComponent, canActivate: [AuthGuard] }, */
    { path: 'snapshots/:endpointId/:snapshotsId', component: ModalSnapshotsComponent, outlet: 'modal', canActivate: [AuthGuard] },
    { path: 'manage-snapshots/:dashboardId', component: ModalSnapshotsComponent, outlet: 'modal', canActivate: [AuthGuard] },
    { path: 'modal-change-value/:endpointId/:endpointType:/:component', component: ModalChangeValueEndpointsComponent, outlet: 'modal', canActivate: [AuthGuard] },
    { path: 'dashboards', component: DashboardsComponent, canActivate: [AuthGuard] },
    {
      path: 'plan',
      loadChildren: () => import('./plans/plans.module').then(m => m.PlansModule),
      canActivate: [AuthGuard],
    },
    { path: 'plans', component: PlansComponent, canActivate: [AuthGuard]},
];

export const routes: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules });
